__turbopack_context__.v({
  "alert-banner": "unavailable-course-module-scss-module__Z6K6rG__alert-banner",
  "container": "unavailable-course-module-scss-module__Z6K6rG__container",
});
